
export interface RivhitPricingRow {
  price_nis?: number;
  quantity?: number;
}

/**
 * Picks the best price from a list of Rivhit pricing rows based on quantity.
 * Rivhit returns multiple rows for volume discounts.
 */
export function pickBestCustomerPrice(
  pricingRows: RivhitPricingRow[],
  quantity: number,
  fallbackPrice: number
): number {
  const rows = pricingRows
    .filter((row) => row.price_nis != null)
    .map((row) => ({
      minQuantity: row.quantity ?? 1,
      price: row.price_nis as number,
    }))
    .sort((a, b) => a.minQuantity - b.minQuantity);

  if (rows.length === 0) return fallbackPrice;

  // Find the highest minQuantity that is still <= current quantity
  const applicable = rows.filter((row) => row.minQuantity <= quantity);
  if (applicable.length > 0) {
    return applicable[applicable.length - 1].price;
  }

  // If quantity is less than all minQuantities, use the lowest tier
  return rows[0].price;
}

/**
 * Extracts a numeric Rivhit customer ID from various string formats (e.g. "C12345", "12345").
 */
export function extractRivhitCustomerId(customerId: string | number): number | null {
  if (typeof customerId === 'number') return customerId;
  const match = customerId.match(/(\d+)$/);
  return match ? Number(match[1]) : null;
}
